import React from 'react';
import { useContext } from 'react';
import { AppContext } from '@/Components/Context/AppContext';
import { fetchWithAuthentication, toast } from '@/Helpers/general';
import { Button } from 'primereact/button';
import { useState } from 'react';

const DownloadButton = ({ doc, margin, size = '' }) => {
    const { toastRef } = useContext(AppContext);
    const [downloadLoading, setDownloadLoading] = useState(false);

    async function downloadDocument(doc) {
        setDownloadLoading(true);

        const response = await fetchWithAuthentication(doc.view_url);

        if (response) {
            const blob = await response.blob();
            const link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);
            link.download = doc.name;
            link.click();

            setDownloadLoading(false);

        } else {
            toast(toastRef, 'error', 'Error downloading document.');
            setDownloadLoading(false);
        }
    }

    return (
        <Button
            className={'p-button-icon-only download p-button' + (size == 'small' ? '-sm' : '' ) + (' ml-' + margin)}
            loading={downloadLoading}
            loadingIcon="pi pi-spin pi-sun"
            onClick={() => {
                downloadDocument(doc);
            }}
            icon="pi pi-download"
        />
    );
};

export default DownloadButton;